@let showClearButton = canResetToDefault();
<div class="shared-select-with-search" [class]="selectClass">
  <mat-select
    [(ngModel)]="selectionModel"
    [multiple]="multiple"
    [placeholder]="placeholder"
    [panelClass]="panelClass"
    [class]="selectClass"
    [class.mat-mdc-select-invalid]="isInvalid"
    [class.select-with-clear]="showClearButton"
    [disabled]="disabled"
    [compareWith]="compareItems"
    [tooltip]="tooltip"
    (closed)="onClosed()"
  >
    @if (iconKey && !multiple && selectionModel && !$any(selectionModel).length) {
      <mat-select-trigger class="ellipsis-trigger" shared-title-if-ellipse>
        <svg-icon [key]="iconKey" />
        <span class="label">{{ $any(selectionModel).label }}</span>
      </mat-select-trigger>
    } @else if (iconKey && multiple && triggerLabel != null) {
      <mat-select-trigger class="ellipsis-trigger" shared-title-if-ellipse>
        <svg-icon [key]="iconKey" />
        <span class="label">{{ triggerLabel }}</span>
      </mat-select-trigger>
    } @else if (!iconKey && multiple && triggerLabel != null) {
      <mat-select-trigger class="ellipsis-trigger" shared-title-if-ellipse>
        <span class="label">{{ triggerLabel }}</span>
      </mat-select-trigger>
    }

    @if (selectAllItem) {
      <mat-option
        #selectAllOption
        [class.bottom-divider]="!fixedItems || fixedItems.length === 0"
        [value]="selectAllItem"
        [tooltip]="selectAllItem.tooltip"
        [showDelay]="500"
        (click)="onSelectAllClick(selectAllOption.selected)"
        shared-title-if-ellipse
        >{{ selectAllItem.label }}</mat-option
      >
    }

    @for (item of fixedItemsWithoutGroup; track trackById($index, item); let isLast = $last) {
      <mat-option
        #option
        [class.bottom-divider]="isLast"
        [disabled]="item.disabled ?? false"
        [value]="item"
        [tooltip]="item.tooltip"
        [showDelay]="500"
        (click)="onFixedItemClick(item, option.selected)"
        shared-title-if-ellipse
        >{{ item.label }}</mat-option
      >
    }

    @if (items?.length > 5) {
      <mat-option>
        <shared-select-search [(ngModel)]="filter" [searchPlaceholder]="searchPlaceholder" />
      </mat-option>
    }

    @for (group of groups$ | async; track group.label) {
      @if (group.label && (groups$ | async).length > 1) {
        <mat-optgroup>
          <b>{{ group.label | uppercase }}</b>
          @for (item of group.items; track trackById($index, item)) {
            <mat-option
              [disabled]="item.disabled ?? false"
              [value]="item"
              [tooltip]="item.tooltip"
              [showDelay]="500"
              (click)="isFixedItemInGroup(item, group) ? onFixedItemClick(item, $any($event.target).selected) : onItemClick()"
              shared-title-if-ellipse
              >{{ item.label }}{{ item.description ? ' (' + item.description + ')' : '' }}</mat-option
            >
          }
        </mat-optgroup>
      }

      @if (!group.label || (groups$ | async).length === 1) {
        @for (item of group.items; track trackById($index, item)) {
          <mat-option
            [disabled]="item.disabled ?? false"
            [value]="item"
            [tooltip]="item.tooltip"
            [showDelay]="500"
            (click)="isFixedItemInGroup(item, group) ? onFixedItemClick(item, $any($event.target).selected) : onItemClick()"
            shared-title-if-ellipse
            >{{ item.label }}{{ item.description ? ' (' + item.description + ')' : '' }}</mat-option
          >
        }
      }
    }
  </mat-select>
  @if (showClearButton) {
    <button type="button" class="btn btn-outline-secondary clear-button" tooltip="Clear selection" [showDelay]="500" [disabled]="disabled" (click)="resetToDefault()">
      <svg-icon class="color-gray" key="close" size="xs" />
    </button>
  }
</div>
